import { BetAreaPanel } from './BetArea';
export const BaccaratBetAreaPanel = () => {
    return <BetAreaPanel />;
};
